
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    emits: ["input"],
    setup(props, { emit }) {
        const remindsMe = ref(props.value);

        watch(remindsMe, () => {
            emit("input", remindsMe.value);
        });

        return {
            remindsMe
        };
    }
});
